import { createSlice } from "@reduxjs/toolkit";
import { getConversations, getMessages, startDirectConversation } from "./chatThunk";

const initialState = {
  conversations: [],
  conversationsLoaded: false,
  messagesByConversation: {},
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addIncomingMessage: (state, action) => {
      const { conversationId, message } = action.payload;
      const existing = state.messagesByConversation[conversationId] || [];
      state.messagesByConversation[conversationId] = [...existing, message];

      const conversation = state.conversations.find((c) => c._id === conversationId);
      if (conversation) {
        conversation.lastMessage = message;
        conversation.lastMessageAt = message.createdAt;
      }
    },
    addSentMessage: (state, action) => {
      const { conversationId, message } = action.payload;
      const existing = state.messagesByConversation[conversationId] || [];
      state.messagesByConversation[conversationId] = [...existing, message];

      const conversation = state.conversations.find((c) => c._id === conversationId);
      if (conversation) {
        conversation.lastMessage = message;
        conversation.lastMessageAt = message.createdAt;
      }
    },
    // Reconciles an optimistically-sent message with the server-assigned id/timestamp
    applyMessageAck: (state, action) => {
      const { conversationId, clientMsgId, serverMsgId, createdAt } = action.payload;
      const messages = state.messagesByConversation[conversationId];
      if (!messages) return;

      const message = messages.find((m) => m._id === clientMsgId);
      if (!message) return;

      message._id = serverMsgId;
      message.createdAt = createdAt;

      const conversation = state.conversations.find((c) => c._id === conversationId);
      if (conversation?.lastMessage?._id === clientMsgId) {
        conversation.lastMessage._id = serverMsgId;
        conversation.lastMessage.createdAt = createdAt;
        conversation.lastMessageAt = createdAt;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConversations.fulfilled, (state, action) => {
      state.conversations = action.payload?.data?.conversations || [];
      state.conversationsLoaded = true;
    });
    builder.addCase(getMessages.fulfilled, (state, action) => {
      const { conversationId, data } = action.payload;
      state.messagesByConversation[conversationId] = data?.messages || [];
    });
    builder.addCase(startDirectConversation.fulfilled, (state, action) => {
      const conversation = action.payload?.data?.conversation || action.payload?.data;
      if (!conversation?._id) return;
      const existing = state.conversations.find((c) => c._id === conversation._id);
      if (!existing) state.conversations.unshift(conversation);
    });
  },
});

export const { addIncomingMessage, addSentMessage, applyMessageAck } = chatSlice.actions;
export default chatSlice.reducer;
